import { campaignIoAgentConfig } from "./configs/campaign-io.config";
/**
 * Configuration object for every agent, allowing customization of data parsing and other agent-specific logic.
 * These configurations are used internally by mad-sdk to handle different agents and can be extended to add support for new agents.
 * To add a new agent, simply add a new entry to the `AGENT_CONFIGS` object with the appropriate configuration.
 * For example, if you have an agent called "my-agent" that requires custom parsing of `data` on a session event data, you would add:
 * ```
 * "my-agent": {
 *   event: {
 *     data: {
 *       fromService: async (data: unknown, sdk: MadSDK) => {
 *         // custom parsing logic here
 *       }
 *     }
 *   }
 * }
 * ```
 */
export const AGENT_CONFIGS = {
    info: { slug: "informational" },
    "campaign-optimizer": {},
    "campaign-io": campaignIoAgentConfig
};
/** The agent's ADK URL slug, falling back to its {@link AgentName} key when not configured. */
export function agentSlug(agent) {
    return AGENT_CONFIGS[agent]?.slug ?? agent;
}
//# sourceMappingURL=agents.config.js.map